import './Thumbnail.scss'

import React, { useRef, useEffect, ReactNode } from 'react'
import classNames from 'classnames'

import VideoDuration from './VideoDuration'

import useLazyLoadImage from '../hooks/useLazyLoadImage'
import { isPortrait } from '../utils/misc'
import { PosterType } from '../constants/enums'

interface Props {
  className?: string
  imageUrl: string
  alt: string
  posterType?: PosterType
  /**
   * NOTE: isShowLetterbox
   * 이미지의 가로/세로 비율 그대로 박스 내부에 들어가도록 보여줄땐 true, 이미지를 박스에 가득 채워 보여줄땐 false를 지정한다.
   */
  isShowLetterbox?: boolean
  isNew?: boolean
  videoDuration?: number
  progressRatio?: number
  children?: ReactNode
}

export default function Thumbnail({
  className,
  imageUrl,
  alt,
  posterType,
  isShowLetterbox,
  isNew,
  videoDuration,
  progressRatio,
  children,
}: Props) {
  const imageRef = useRef<HTMLImageElement>(null)
  const { isLoaded, imagePosterType, setNextLazyValue } = useLazyLoadImage(imageRef)

  useEffect(() => {
    if (imageUrl && isLoaded) {
      setNextLazyValue(imageUrl)
    }
    // eslint-disable-next-line
  }, [imageUrl])

  return (
    <div
      className={classNames('Thumbnail', className, {
        'Thumbnail--portrait': isPortrait(imagePosterType, posterType),
        'Thumbnail--letterbox': isShowLetterbox && isLoaded && posterType !== imagePosterType,
      })}
    >
      <img
        ref={imageRef}
        className={classNames('Thumbnail__image', {
          'Thumbnail__image--letterbox': isShowLetterbox && isLoaded && posterType !== imagePosterType,
        })}
        alt={alt}
        src={
          isPortrait(imagePosterType, posterType)
            ? '/images/thumbnail-placeholder-portrait.svg'
            : '/images/thumbnail-placeholder.svg'
        }
        data-src={imageUrl}
      />
      {isNew && <div className="Thumbnail__badge">NEW</div>}
      <VideoDuration videoDuration={videoDuration} />
      {progressRatio && <div className="Thumbnail__watchPosition" style={{ width: `${progressRatio}%` }} />}
      {children}
    </div>
  )
}
